import type { MediaKind } from '@mcgames/contracts';

/** The single-image kinds; each upload or import replaces the previous image. */
export type ImageKind = Extract<MediaKind, 'cover' | 'hero' | 'logo' | 'icon'>;

export const IMAGE_KINDS: readonly ImageKind[] = ['cover', 'hero', 'logo', 'icon'];

export const IMAGE_ACCEPT = 'image/png,image/jpeg,image/webp';

export function imageForKind(
  game: {
    coverUrl: string | null;
    heroUrl: string | null;
    logoUrl: string | null;
    iconUrl: string | null;
  },
  kind: ImageKind,
): string | null {
  switch (kind) {
    case 'cover':
      return game.coverUrl;
    case 'hero':
      return game.heroUrl;
    case 'logo':
      return game.logoUrl;
    case 'icon':
      return game.iconUrl;
  }
}
